import { NavLink, Outlet } from "react-router";
import { hub, type Me } from "@/lib/hub";

// The hub's frame around the home, Users and Activity screens: a Midnight top bar with the hub's name, the owners'
// screens, who is signed in, and Sign out. A website's dashboard has its own frame (sites/<kind>/).

const tab = ({ isActive }: { isActive: boolean }) =>
  `flex min-h-11 items-center rounded-lg px-3 text-sm font-bold whitespace-nowrap transition-colors ${isActive ? "bg-offwhite text-midnight" : "text-offwhite/80 hover:bg-offwhite/10 hover:text-offwhite"}`;

export function Shell({ me }: { me: Me }) {
  const signOut = async () => {
    await hub.logout().catch(() => {});
    window.location.assign("/login");
  };
  return (
    <div className="min-h-svh">
      <header className="bg-midnight text-offwhite">
        <div className="mx-auto flex max-w-5xl flex-wrap items-center gap-x-4 gap-y-2 px-4 py-3 sm:px-6">
          <NavLink to="/" className="me-auto py-1 font-bold tracking-tight">
            <span className="font-mono text-[0.7rem] tracking-[0.25em] text-amber uppercase">Dashboards</span>
          </NavLink>
          <nav aria-label="Hub" className="flex gap-1">
            <NavLink to="/" end className={tab}>
              Websites
            </NavLink>
            {me.role === "owner" && (
              <>
                <NavLink to="/users" className={tab}>
                  Users
                </NavLink>
                <NavLink to="/activity" className={tab}>
                  Activity
                </NavLink>
              </>
            )}
          </nav>
          <div className="flex items-center gap-2 text-sm">
            <span className="hidden text-offwhite/80 sm:inline" title={me.email}>
              {me.name || me.email}
            </span>
            <button type="button" onClick={signOut} className="min-h-11 rounded-lg px-3 text-offwhite/80 hover:bg-offwhite/10 hover:text-offwhite">
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-6 sm:px-6 sm:py-10">
        <Outlet />
      </main>
    </div>
  );
}
